import React from 'react';
import { Lock, Unlock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface WorkflowLockBannerProps {
  isWorkflowAdmin: boolean;
  onUnlock: () => void;
}

export const WorkflowLockBanner: React.FC<WorkflowLockBannerProps> = ({
  isWorkflowAdmin,
  onUnlock,
}) => {
  return (
    <div className='flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-1.5 text-sm text-amber-900 shadow-sm dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-200'>
      <Lock className='size-3.5 shrink-0' />
      <span>
        This workflow is locked. You can still edit File Input and Text Input
        fields.
      </span>
      {isWorkflowAdmin && (
        <Button
          variant='ghost'
          size='sm'
          className='ml-1 h-6 px-2 text-xs text-amber-900 hover:bg-amber-100 dark:text-amber-200 dark:hover:bg-amber-900/50'
          onClick={onUnlock}
        >
          <Unlock className='size-3 mr-1' />
          Unlock
        </Button>
      )}
    </div>
  );
};
